'use client'

import { RenderOnScroll } from 'components/RenderOnScroll'
import dynamic from 'next/dynamic'

const DynamicMarketingPlatformImage = dynamic(() =>
	import('./MarketingPlatformImage').then((mod) => mod.MarketingPlatformImage),
)

export const LazyMarketingPlatformImage = () => (
	<RenderOnScroll
		element={<DynamicMarketingPlatformImage />}
		containerCls="w-full"
	/>
)
